<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable || (GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">PA Information and Project Description</p>
            </template>
            <project-description></project-description>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Organization Details</p>
            </template>
            <organization-details></organization-details>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">ESMS pre-screening questions</p>
            </template>
            <esms></esms>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Application and supporting document upload</p>
            </template>
            <documents-upload></documents-upload>
          </grant-wizard-tab>

        </grant-wizard>
      </div>
    </div>
  </div>
</template>
<script>
  import DocumentsUpload from './Steps/DocumentsUpload'
  import OrganizationDetails from './Steps/OrganizationDetails'
  import Esms from './Steps/EsmsQuestionnaire'
  import ProjectDescription from './Steps/ProjectDescription'

  import {EventBus} from '@/event-bus.js';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab} from 'src/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantWizard,
      GrantWizardTab,
      DocumentsUpload,
      OrganizationDetails,
      ProjectDescription,
      Esms
    },
    created() {
      EventBus.$off('set-active-tab');

      EventBus.$on('wizard-save-progress', data => {
        this.onBeforeSaveProgress(data);
      });

      EventBus.$on('wizard-complete-progress', data => {
        this.onBeforeCompleteProgress(data);
      });
    },
    methods: {
      async onBeforeSaveProgress(data) {
        /*let valid = await this.validate();
        if (valid) {
          EventBus.$emit('cn-grant-save-progress', data);
        }*/
        EventBus.$emit('cn-grant-save-progress', data);
      },

      async onBeforeCompleteProgress(data) {
        let valid = await this.validate();
        if (!valid) {
          return;
        }

        var submitConfirmation = await this.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          EventBus.$emit('cn-grant-complete-progress', data);
        }
      },

      async validate() {
        let valid = true;
        let vm = this;
        let mandatoryFields = [
          {
            translation: vm.$t('medium_grant.technical__1_region'),
            value: GrantForm.regionId
          },
          {
            translation: vm.$t('medium_grant_cn.document_upload_concept_technical_proposal'),
            value: GrantForm.files.technical.cnConceptTechnicalProposal
          },
          {
            translation: 'Diagnostic tool document',
            value: GrantForm.files.technical.diagnosticToolDoc
          },
          /*{
            translation: vm.$t('medium_grant_cn.document_upload_esms_questionnaire'),
            value: GrantForm.files.technical.cnEsmsQuestionnaire
          },*/
          {
            translation: vm.$t('medium_grant_cn.document_upload_applicant_declaration'),
            value: GrantForm.files.technical.cnApplicantDeclaration
          },
          /*{
            translation: vm.$t('medium_grant_cn.document_upload_coapplicant_declaration'),
            value: GrantForm.files.technical.cnCoapplicantDeclarationDocument
          },*/
          {
            translation: 'Due diligence questionnaire',
            value: GrantForm.files.technical.cnDueDiligence
          },
          {
            translation: 'Start Date is required',
            value: GrantForm.model.cndescription.startDate
          },
          {
            translation: 'End Date is required',
            value: GrantForm.model.cndescription.endDate
          },
          {
            translation: 'Organization name is required',
            value: GrantForm.model.cndescription.nameOfLeadOrg
          },
          {
            translation: vm.$t('medium_grant.technical__1_total_funding'),
            value: GrantForm.model.cndescription.totalFunding
          },
          {
            translation: 'Total funding requested',
            value: GrantForm.model.cndescription.totalCoFunding
          }
        ];
        let errorFields = [];
        mandatoryFields.forEach(item => {
          if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length) || (typeof item.value == "object" && Object.keys(item.value).length == 0 )) {
            errorFields.push(item.translation);
          }
        })

        if (errorFields.length) {
          valid = false;
          await this.showNotificationMandatoryFields(errorFields);

          EventBus.$emit('set-active-tab', {
            masterNickname: 'technical',
            masterIndex: 0,
            childIndex: 0,
            validate: true
          });
        }
        return valid;
      },

      showNotificationMandatoryFields(fields) {
        for (var i = 0; i < fields.length; i++) {
          fields[i] = "* " + fields[i];
        }
        let fieldsHtml = '<div class="text-danger">' + fields.join("<br>") + '</div>';
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__mandatory_fields', [fieldsHtml]).split("\n").join("<br>"),
          type: 'warning',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },

      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_application'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_application'),
        })
      }
    }
  };
</script>
